/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { TbLayoutList, TbLayoutKanban } from "react-icons/tb";
import { IoSearch } from "react-icons/io5";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useDispatch } from "react-redux";
import {
  deleteProject,
  geProjectByID,
  getArchiveProject,
  getProject,
  InsertProject,
} from "../../Redux/ProjectSlice";
import { BiEdit } from "react-icons/bi";
import Loading from "../Common/Loading";
import { MdDeleteForever } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import AddProject from "./AddProject";
import sweetAlert from "../Common/sweetAlert";
import { formatDate, Phase } from "../Common/Common";
import { GoArchive } from "react-icons/go";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import toast from "react-hot-toast";
import ProjectHome from "./ProjectHome";
import moment from "moment";
import Pagination from "../Common/Pagination";

// shraddha

const Projects = ({
  isVisible,
  setIsVisible,
  setSidebarOpen,
  sidebarOpen,
  isDark,
  setIsDark,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [Project, setProject] = useState([]);
  const [loading, setloading] = useState(true);
  const [Projectpage, setProjectpage] = useState(false);
  const [Tab, setTab] = useState("list");
  const [showModal, setshowModal] = useState(false);
  const [loadFrist, setloadFrist] = useState(true);
  const [selectedProjectId, setSelectedProjectId] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [EditProjectData, setEditProjectData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortedField, setSortedField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [activeStatusTab, setActiveStatusTab] = useState("all");
  const [openActionMenuId, setOpenActionMenuId] = useState(null);
  const [lists, setLists] = useState({
    Kickoff: [],
    Planning: [],
    Implementation: [],
    Review: [],
    Closing: [],
  });

  useEffect(() => {
    const handleOutsideClick = () => setOpenActionMenuId(null);
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  useEffect(() => {
    if (loadFrist) {
      fetchProject();
      setloadFrist(false);
    }
  }, [loadFrist, Project]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const handleTab = (tabId) => { setTab(tabId); setSearchTerm(''); setloadFrist(true); };

  const toggleModal = () => {
    setshowModal(!showModal);
    setEditProjectData([]);
  };

  // Status helpers
  const getProjectStatus = (item) => {
    if (item?.canceled === 0) return 'cancelled';
    if (item?.canceled === 1) return 'completed';
    return 'inprogress';
  };

  const filteredProject = Project.filter((item) => {
    const matchSearch = item?.title && item?.title.toLowerCase().includes(searchTerm.toLowerCase());
    if (activeStatusTab === "all") return matchSearch;
    const status = getProjectStatus(item);
    if (activeStatusTab === "inprogress") return matchSearch && status === 'inprogress';
    if (activeStatusTab === "completed") return matchSearch && status === 'completed';
    if (activeStatusTab === "onhold") return matchSearch && item?.phase === 'Planning';
    if (activeStatusTab === "notstarted") return matchSearch && item?.phase === 'Kickoff';
    return matchSearch;
  });

  const handleSort = (field) => {
    if (sortedField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortOrder("asc");
      setSortedField(field);
    }
  };

  const sortData = (data, field, order) => {
    const sortedData = [...data];
    sortedData.sort((a, b) => {
      const aTrimmed = a[field]?.trim();
      const bTrimmed = b[field]?.trim();
      if (order === "asc") {
        return aTrimmed?.localeCompare(bTrimmed);
      }
    });
    return sortedData;
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortData(filteredProject, sortedField, sortOrder).slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredProject.length / rowsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      setSelectedProjectId(Project && Project.map((id) => id.projectID));
    } else {
      setSelectedProjectId([]);
    }
  };

  const handleCheckboxChange = (productId) => {
    let updatedSelectedProjectIds;
    if (selectedProjectId.includes(productId)) {
      updatedSelectedProjectIds = selectedProjectId.filter((id) => id !== productId);
    } else {
      updatedSelectedProjectIds = [...selectedProjectId, productId];
    }
    setSelectedProjectId(updatedSelectedProjectIds);
    const allRowsSelected = updatedSelectedProjectIds.length === Project.length;
    setSelectAll(allRowsSelected);
  };

  const DeleteProject = async () => {
    try {
      const result = await sweetAlert.confirm("Are you sure?", "You won't be able to revert this!");
      if (result.isConfirmed) {
        dispatch(deleteProject(selectedProjectId)).then((res) => {
          if (res.payload.status === true) {
            setloadFrist(true);
            setCurrentPage(1);
          }
        });
        setProjectpage(false);
        sweetAlert.success("Deleted successfully");
      }
      setSelectedProjectId([]);
      setSelectAll(false);
    } catch (error) {
      console.error("Error:", error);
      sweetAlert.error("An error occurred");
    }
  };

  const fetchProject = () => {
    setloading(true);
    dispatch(getProject({ IsArchived: false })).then((res) => {
      if (res?.payload?.status === true) {
        setProject(res.payload.data);
        const timer = setTimeout(() => { setloading(false); }, 500);
        return () => clearTimeout(timer);
      }
    });
  };

  const EditProject = async (id) => {
    const result = await dispatch(geProjectByID(id));
    setEditProjectData(result.payload.data);
  };

  const updatePhaseStage = async (draggedItem, Phasestage) => {
    setloading(true);
    const Params = { ...draggedItem, phase: Phasestage.name };
    try {
      const res = await dispatch(InsertProject(Params));
      toast.remove();
      if (res.payload.status === true) { setloadFrist(true); }
    } catch (error) { console.error("Error:", error); }
  };

  const getList = (droppableId) => lists[droppableId] || [];
  const setList = (droppableId, list) => {
    setLists((prevLists) => ({ ...prevLists, [droppableId]: list }));
  };

  const handleOnDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    const sourceList = getList(source.droppableId);
    const destList = getList(destination.droppableId);
    if (sourceList && destList) {
      const draggedItemId = parseInt(result.draggableId);
      const draggedItem = Project.find((item) => item.projectID === draggedItemId);
      const updatedSourceList = sourceList.filter((item) => item.projectID !== draggedItemId);
      const updatedDestList = [
        ...destList.slice(0, destination.index),
        draggedItem,
        ...destList.slice(destination.index),
      ];
      setList(source.droppableId, updatedSourceList);
      setList(destination.droppableId, updatedDestList);
      const Phasestage = Phase.find(x => x.id === destination.droppableId);
      updatePhaseStage(draggedItem, Phasestage);
    }
  };

  const extractTasks = (data) => {
    const phases = ['phaseunassignedMaster', 'kickoffMaster', 'planningMaster', 'implementationMaster', 'reviewMaster', 'closingMaster'];
    let tasks = [];
    phases.forEach(phase => { if (data[phase]) { data[phase].forEach(item => { tasks.push(item); }); } });
    return tasks;
  };

  // Stats derived from data
  const totalProjects = Project.length;
  const inProgressCount = Project.filter(p => p?.canceled !== 0 && p?.canceled !== 1).length;
  const completedCount = Project.filter(p => p?.canceled === 1).length;
  const onHoldCount = Project.filter(p => p?.phase === 'Planning').length;
  const notStartedCount = Project.filter(p => p?.phase === 'Kickoff').length;

  // Status badge helper
  const getStatusBadge = (item) => {
    if (item?.canceled === 0) return <span className="crm-badge crm-badge-cancelled">Cancelled</span>;
    if (item?.canceled === 1) return <span className="crm-badge crm-badge-completed">Completed</span>;
    if (item?.phase === 'Planning') return <span className="crm-badge crm-badge-onhold">On Hold</span>;
    if (item?.phase === 'Kickoff') return <span className="crm-badge crm-badge-notstarted">Not Started</span>;
    return <span className="crm-badge crm-badge-inprogress">In Progress</span>;
  };

  // Priority badge helper
  const getPriorityBadge = (item) => {
    const labels = item?.labelName ? item.labelName.split(',') : [];
    if (labels.includes('inProgress')) return <span className="crm-priority"><span className="crm-dot crm-dot-high"></span>High</span>;
    if (labels.includes('onHold')) return <span className="crm-priority"><span className="crm-dot crm-dot-medium"></span>Medium</span>;
    return <span className="crm-priority"><span className="crm-dot crm-dot-low"></span>Low</span>;
  };

  const tabs = [
    { id: 'all', label: `All Projects (${totalProjects})` },
    { id: 'inprogress', label: `In Progress (${inProgressCount})` },
    { id: 'completed', label: `Completed (${completedCount})` },
    { id: 'onhold', label: `On Hold (${onHoldCount})` },
    { id: 'notstarted', label: `Not Started (${notStartedCount})` },
  ];

  return (
    <>
      <div className="flex flex-1">
        <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">

          {/* Page Header */}
          <div className="crm-page-header">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="crm-page-title">Projects</h1>
                <ol className="crm-breadcrumb">
                  <li><a href="/Analytics">Disploy</a></li>
                  <li>/</li>
                  <li className="active">Projects</li>
                </ol>
              </div>
              <button className="crm-new-btn" onClick={() => setshowModal(true)}>
                <FaPlus size={11} />
                New Project
              </button>
            </div>
          </div>

          {!loading && Project?.length === 0 && !Projectpage ? (
            <ProjectHome setProjectpage={setProjectpage} />
          ) : (
            <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">

              {/* Stat Cards */}
              <div className="crm-stats-row">
                <div className="crm-stat-card crm-card-indigo">
                  <div className="flex items-start gap-3">
                    <div className="stat-icon stat-icon-indigo"><svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></svg></div>
                    <div>
                      <p className="stat-label">Total Projects</p>
                      <p className="stat-value">{totalProjects}</p>
                      {/* <p className="stat-trend-up">↑ 20% vs last 7 days</p> */}
                    </div>
                  </div>
                </div>
                <div className="crm-stat-card crm-card-blue">
                  <div className="flex items-start gap-3">
                    <div className="stat-icon stat-icon-blue"><svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></svg></div>
                    <div>
                      <p className="stat-label">In Progress</p>
                      <p className="stat-value">{inProgressCount}</p>
                      {/* <p className="stat-trend-up">↑ 15% vs last 7 days</p> */}
                    </div>
                  </div>
                </div>
                <div className="crm-stat-card crm-card-green">
                  <div className="flex items-start gap-3">
                    <div className="stat-icon stat-icon-green"><svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg></div>
                    <div>
                      <p className="stat-label">Completed</p>
                      <p className="stat-value">{completedCount}</p>
                      {/* <p className="stat-trend-up">↑ 25% vs last 7 days</p> */}
                    </div>
                  </div>
                </div>
                <div className="crm-stat-card crm-card-orange">
                  <div className="flex items-start gap-3">
                    <div className="stat-icon stat-icon-orange"><svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg></div>
                    <div>
                      <p className="stat-label">On Hold</p>
                      <p className="stat-value">{onHoldCount}</p>
                      {/* <p className="stat-trend-down">↓ 10% vs last 7 days</p> */}
                    </div>
                  </div>
                </div>
                <div className="crm-stat-card crm-card-gray">
                  <div className="flex items-start gap-3">
                    <div className="stat-icon stat-icon-gray"><svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="8" y1="12" x2="16" y2="12" /></svg></div>
                    <div>
                      <p className="stat-label">Not Started</p>
                      <p className="stat-value">{notStartedCount}</p>
                      {/* <p className="stat-trend-up">↑ 5% vs last 7 days</p> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Main Panel */}
              <div className="crm-panel">
                {/* Tab Navigation + View Toggle */}
                <div className="flex items-center justify-between px-4 pt-2 border-b border-gray-100">
                  <div className="crm-tabs" style={{ borderBottom: 'none' }}>
                    {tabs.map(t => (
                      <button key={t.id} className={`crm-tab-btn${activeStatusTab === t.id ? ' active' : ''}`}
                        onClick={() => { setActiveStatusTab(t.id); setCurrentPage(1); }}>
                        {t.label}
                      </button>
                    ))}
                    {/* <button className="crm-tab-btn add-view"><FaPlus size={10} /> Add View</button> */}
                  </div>
                  <div className="flex items-center gap-2 ml-4 pb-1 shrink-0">
                    <div className="crm-view-toggle">
                      <button className={`crm-view-btn${Tab === 'list' ? ' active' : ''}`} onClick={() => handleTab('list')} title="List View">
                        <TbLayoutList size={16} />
                      </button>
                      <button className={`crm-view-btn${Tab === 'phase' ? ' active' : ''}`} onClick={() => handleTab('phase')} title="Board View">
                        <TbLayoutKanban size={16} />
                      </button>
                    </div>
                    {selectedProjectId.length > 0 && (
                      <button className="crm-action-btn text-red-500" onClick={DeleteProject} title="Delete selected">
                        <MdDeleteForever size={18} />
                      </button>
                    )}
                  </div>
                </div>

                {/* Filter Bar */}
                <div className="px-4">
                  <div className="crm-filter-bar">
                    
                    <div className="ml-auto crm-search-box">
                      <IoSearch size={14} />
                      <input
                        type="text"
                        placeholder="Search projects..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* Content */}
                {loading && <div className="h-64 flex items-center justify-center"><Loading /></div>}

                {/* Board / Kanban View */}
                {!loading && Tab === "phase" && (
                  <div className="p-4">
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                      <div className="flex gap-4 overflow-x-auto pb-2">
                        {Phase.map((x) => {
                          const phaseProjects = filteredProject.filter((row) => row.phase === x.name);
                          return (
                            <Droppable key={x.id} droppableId={x.id}>
                              {(provided) => (
                                <div ref={provided.innerRef} className="min-w-[220px] flex-1">
                                  <div className="bg-gray-50 rounded-lg p-3">
                                    <div className="flex items-center justify-between mb-3">
                                      <h3 className="font-semibold text-sm text-gray-700">{x.name}</h3>
                                      <span className="text-xs bg-gray-200 text-gray-600 rounded-full px-2 py-0.5">{phaseProjects.length}</span>
                                    </div>
                                    {phaseProjects.map((proj, index) => (
                                      <Draggable key={proj.projectID} draggableId={proj.projectID.toString()} index={index}>
                                        {(provided) => (
                                          <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-3 mb-2 cursor-pointer hover:shadow-md transition-shadow"
                                              onClick={() => navigate(`/Projects/${proj.projectID}`)}>
                                              <p className="font-medium text-sm text-gray-800 mb-1">{proj?.title}</p>
                                              <p className="text-xs text-gray-500 mb-2">{proj?.organizationName || ''}</p>
                                              <div className="flex items-center justify-between">
                                                {getStatusBadge(proj)}
                                                <span className="text-xs text-gray-400">{formatDate(proj?.endDateTime)}</span>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </Draggable>
                                    ))}
                                    {provided.placeholder}
                                  </div>
                                </div>
                              )}
                            </Droppable>
                          );
                        })}
                      </div>
                    </DragDropContext>
                  </div>
                )}

                {/* List View */}
                {!loading && Tab === "list" && (
                  <>
                    <div className="crm-table-wrapper" style={{ border: 'none', borderRadius: 0 }}>
                      <table className="crm-table">
                        <thead>
                          <tr>
                            <th style={{ width: 40 }}>
                              <input type="checkbox" checked={selectAll} onChange={handleSelectAll}
                                className="w-4 h-4 rounded border-gray-300 accent-indigo-600" />
                            </th>
                            <th onClick={() => handleSort("title")} className="cursor-pointer">
                              Project <span className="text-gray-300 ml-1">↕</span>
                            </th>
                            <th>Client</th>
                            <th>Owner</th>
                            <th className="center">Status</th>
                            <th className="center">Priority</th>
                            <th>Progress</th>
                            <th>Start Date</th>
                            <th>Due Date</th>
                            <th className="center">Tasks</th>
                            <th className="center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentRows && currentRows.length > 0 ? (
                            currentRows.map((item, index, arr) => {
                              const tasks = extractTasks(item || {});
                              const totalTasks = tasks.length;
                              const completedTasks = tasks.filter(task => task.markAsDone).length;
                              const progress = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;
                              const showUpward = index >= arr.length - 2 && arr.length > 1;
                              return (
                                <tr key={index}>
                                  <td>
                                    <input type="checkbox"
                                      checked={selectedProjectId.includes(item.projectID)}
                                      onChange={() => handleCheckboxChange(item.projectID)}
                                      className="w-4 h-4 rounded border-gray-300 accent-indigo-600" />
                                  </td>
                                  <td>
                                    <div className="cursor-pointer" onClick={() => navigate(`/Projects/${item?.projectID}`)}>
                                      <p className={`font-semibold text-gray-800 text-sm ${item?.canceled === 0 ? 'line-through text-red-400' : ''}`}>
                                        {item?.title}
                                      </p>
                                      <p className="text-xs text-gray-400 mt-0.5">PRJ-{item?.projectID}</p>
                                    </div>
                                  </td>
                                  <td>
                                    <span className="text-sm text-gray-600">{item?.organizationName || '—'}</span>
                                  </td>
                                  <td>
                                    <div className="flex items-center gap-2">
                                      <div className="w-7 h-7 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-xs font-bold">
                                        {(item?.ownerName || 'D').charAt(0).toUpperCase()}
                                      </div>
                                      <span className="text-sm text-gray-600">{item?.ownerName || 'Dhruv'}</span>
                                    </div>
                                  </td>
                                  <td className="center">{getStatusBadge(item)}</td>
                                  <td className="center">{getPriorityBadge(item)}</td>
                                  <td>
                                    <div className="crm-progress-wrap">
                                      <div className="crm-progress-track">
                                        <div className="crm-progress-fill" style={{ width: `${progress || 4}%` }}></div>
                                      </div>
                                      <span className="crm-progress-label">{progress}%</span>
                                    </div>
                                  </td>
                                  <td className="text-sm text-gray-500">{formatDate(item?.startDateTime) || '—'}</td>
                                  <td className={`text-sm ${item?.endDateTime && new Date(item.endDateTime) < new Date() && item?.canceled !== 1 ? 'crm-date-overdue' : 'text-gray-500'}`}>
                                    {formatDate(item?.endDateTime) || '—'}
                                  </td>
                                  <td className="center">
                                    <span className="text-sm text-gray-600 font-medium">{totalTasks}</span>
                                  </td>
                                  <td className="center">
                                    <div className="relative inline-block text-left">
                                      <button
                                        className="crm-action-btn p-1.5 hover:bg-slate-100 rounded-md transition-colors text-slate-500 hover:text-slate-800"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setOpenActionMenuId(openActionMenuId === item.projectID ? null : item.projectID);
                                        }}
                                      >
                                        <BsThreeDotsVertical size={14} />
                                      </button>

                                      {openActionMenuId === item.projectID && (
                                        <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                          {item?.canceled !== 0 && (
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setshowModal(true);
                                                EditProject(item?.projectID);
                                                setOpenActionMenuId(null);
                                              }}
                                              className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                            >
                                              <BiEdit size={14} className="text-indigo-500" />
                                              <span>Edit Project</span>
                                            </button>
                                          )}
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              dispatch(getArchiveProject({ ProjectID: item.projectID, IsArchived: true }))
                                                .then((res) => { if (res?.payload?.status === true) setloadFrist(true); });
                                              setOpenActionMenuId(null);
                                            }}
                                            className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                          >
                                            <GoArchive size={14} className="text-indigo-500" />
                                            <span>Archive</span>
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="11" className="text-center py-12 text-gray-400">
                                <div className="flex flex-col items-center gap-2">
                                  <svg width="40" height="40" fill="none" stroke="#d1d5db" strokeWidth="1.5" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></svg>
                                  <p className="font-medium">No projects found</p>
                                  <p className="text-sm">Try adjusting your search or filters</p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <Pagination setCurrentPage={setCurrentPage} handlePageChange={handlePageChange}
                      currentPage={currentPage} sidebarOpen={sidebarOpen} totalPages={totalPages}
                      length={Project?.length} setrowsPerPage={setrowsPerPage} rowsPerPage={rowsPerPage} name='Projects' />
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <AddProject
          toggleModal={toggleModal}
          setloadFrist={setloadFrist}
          EditProjectData={EditProjectData}
        />
      )}
    </>
  );
};

export default Projects;
